import styled from 'styled-components';
export const Container = styled.div `
  height: 8px;
  background-color: var(--color-neutral-200);
  border-radius: var(--border-radius-lg);
  margin-left: var(--spacing-size-xs);
  margin-right: var(--spacing-size-xs);
  width: 100%;

  .bar {
    height: 100%;
    width: ${(props) => `${props.progress}%`};
    background-color: var(--color-brand-300);
    border-radius: var(--border-radius-lg);
  };

  .text {
    margin-top: var(--spacing-size-5xs);
    font-size: var(--font-size-xs);
    text-align: right;
    font-weight: var(--font-weight-semibold);
  };
`;
//# sourceMappingURL=style.js.map